import { render, staticRenderFns } from "./DeliveryNoteItemsTree.vue?vue&type=template&id=a5a10efe&scoped=true"
import script from "./DeliveryNoteItemsTree.vue?vue&type=script&lang=js"
export * from "./DeliveryNoteItemsTree.vue?vue&type=script&lang=js"
import style0 from "./DeliveryNoteItemsTree.vue?vue&type=style&index=0&id=a5a10efe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a10efe",
  null
  
)

export default component.exports